<!--目录面板-->
<template>
  <div :class="[isPc?'content-container-pc':'content-container']">
    <div class="content-date-list" :class="{'beauty-scroll': isPc}">
      <div v-if="liveType === 'all'">
        <div
            v-for="(item, index) in contentObj.stream_list"
            :key="index"
            :class="['date-list-item', (item.play_type == 'live' && streamId==item.stream_id)||(item.play_type == 'video' && streamId==item.stream_id && currentVideoId==item.id)? 'active' : '']"
            @click="exchangeContent(item, item.play_type)"
        >
          <template v-if="item.play_type == 'live'">
            <div class="list-item-img">
              <van-image
                  width="1.25rem"
                  height="0.7rem"
                  radius="10px"
                  :src="item.cover_url"
              />
            </div>
            <div class="list-item-info">
              <div class="item-info-title">{{item.title}}</div>
              <div class="item-info-time">
                <van-image
                    v-if="(Number(new Date()) <= Number(new Date(item.end_time.replace(/-/g,'\/'))))&&(Number(new Date()) >= Number(new Date(item.live_start_time.replace(/-/g,'\/'))))"
                    width="0.22rem"
                    height="0.22rem"
                    :src="streamId==item.stream_id?require('@/assets/imgs/live-curr.gif'):require('@/assets/imgs/live-other.gif')"
                />
                <van-image
                    v-else
                    width="0.22rem"
                    height="0.22rem"
                    :src="streamId==item.stream_id?require('@/assets/imgs/live-curr.png'):require('@/assets/imgs/live-other.png')"
                />
                {{item.show_time || ''}}
              </div>
            </div>
          </template>
          <template v-if="item.play_type == 'video'">
            <div class="list-item-img">
              <van-image
                  width="1.25rem"
                  height="0.7rem"
                  radius="10px"
                  :src="item.video_pic || item.cover_url"
              />
            </div>
            <div class="list-item-info">
              <div class="item-info-title">{{getStr_before(item.title ? item.title : '','##')}}</div>
              <div class="item-info-time">
                <div style="display: flex;">
                  <van-icon :name="streamId==item.stream_id&&currentVideoId==item.id?'pause-circle-o':'play-circle-o'" />
                  <div>{{item.duration_desc}}</div>
                </div>
                <div style="display: flex;" v-if="getStr_after(item.title ? item.title : '','##')">
                  <van-icon name="clock-o" />
                  <div>{{getStr_after(item.title ? item.title : '','##')}}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-if="liveType === 'live'">
        <div
            v-for="(item, index) in contentObj.stream_list"
            :key="index"
        >
          <template v-if="item.play_type == 'live'">
            <div :class="['date-list-item', (item.play_type == 'live' && streamId==item.stream_id)||(item.play_type == 'video' && streamId==item.stream_id && currentVideoId==item.id)? 'active' : '']"
                 @click="exchangeContent(item, item.play_type)">
              <div class="list-item-img">
                <van-image
                    width="1.25rem"
                    height="0.7rem"
                    radius="10px"
                    :src="item.cover_url"
                />
              </div>
              <div class="list-item-info">
                <div class="item-info-title">{{item.title}}</div>
                <div class="item-info-time">
                  <van-image
                      v-if="(Number(new Date()) <= Number(new Date(item.end_time.replace(/-/g,'\/'))))&&(Number(new Date()) >= Number(new Date(item.live_start_time.replace(/-/g,'\/'))))"
                      width="0.22rem"
                      height="0.22rem"
                      :src="streamId==item.stream_id?require('@/assets/imgs/live-curr.gif'):require('@/assets/imgs/live-other.gif')"
                  />
                  <van-image
                      v-else
                      width="0.22rem"
                      height="0.22rem"
                      :src="streamId==item.stream_id?require('@/assets/imgs/live-curr.png'):require('@/assets/imgs/live-other.png')"
                  />
                  {{item.show_time || ''}}
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

      <div v-if="liveType === 'video'">
        <div
            v-for="(item, index) in contentObj.stream_list"
            :key="index"
        >
          <template v-if="item.play_type == 'video'">
            <div
                :class="['date-list-item', (item.play_type == 'live' && streamId==item.stream_id)||(item.play_type == 'video' && streamId==item.stream_id && currentVideoId==item.id)? 'active' : '']"
                @click="exchangeContent(item, item.play_type)">
              <div class="list-item-img">
                <van-image
                    width="1.25rem"
                    height="0.7rem"
                    radius="10px"
                    :src="item.video_pic || item.cover_url"
                />
              </div>
              <div class="list-item-info">
                <div class="item-info-title">{{getStr_before(item.title ? item.title : '','##')}}</div>
                <div class="item-info-time">
                  <div style="display: flex;">
                    <van-icon :name="streamId==item.stream_id&&currentVideoId==item.id?'pause-circle-o':'play-circle-o'" />
                    <div>{{item.duration_desc}}</div>
                  </div>
                  <div style="display: flex;" v-if="getStr_after(item.title ? item.title : '','##')">
                    <van-icon name="clock-o" />
                    <div>{{getStr_after(item.title ? item.title : '','##')}}</div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    contentObj: {
      type: Object,
      default: function () {
        return {}
      }
    },
    streamId: {
      type: [String, Number],
      default: ''
    },
    videoId: {
      // 要回显的回放id
      type: [String, Number],
      default: ''
    },
    liveType:{
      type:String,
    }
  },
  data() {
    return {
      activeIndex: 0,
      currentId: '', // 当前观看直播流ID
      currentVideoId: '', // 回放状态下选择的回放ID
    }
  },
  computed:{
    ...mapState(['isPc'])
  },
  watch: {
    'videoId': {
      immediate: true,
      handler: function(val){
        this.currentVideoId = val
      }
    }
  },
  methods: {
    //截取字符串
    getStr_before(string,str){
      var str_before = string.split(str)[0];
      return str_before;
    },
    //截取字符串
    getStr_after(string,str){
      var str_after = string.split(str)[1];
      return str_after;
    },
    // 点击切换直播、回放
    exchangeContent(item, type) {
      // 点击视频
      if (type == 'video') {
        if(this.streamId==item.stream_id){
          // 当前房间内切换视频
          this.currentVideoId = item.id
          this.$emit('watchVideo', {
            video_url: item.video_url,
            type:type
          })
        }else {
          // 跳转不同房间的视频
          this.currentVideoId = ''
          this.$emit('exchangeLive', {...item, type})
        }
      } else {
        // 跳转直播间
        this.currentVideoId = ''
        this.$emit('exchangeLive', { ...item, type })
      }
    },
    // 自动滚动到所选日期
    // scrollToDate(){
    //   const list = this.contentObj.date_range_desc.filter(v=>v.is_default)
    //     const _this = this
    //     if(list.length > 0){
    //       this.$nextTick(()=>{
    //         _this.$refs.contentDate.scrollTo({
    //           left: _this.$refs[`dateRange${list[0].value}`][0].offsetLeft - _this.$refs.contentDate.offsetLeft,
    //           top: 0,
    //           behavior: 'smooth'
    //         })
    //       })
    //     }
    // }
  },
}
</script>

<style lang="less" scoped>
//.van-ellipsis{
//  width: 200px;
//  display: -webkit-box;
//  text-overflow: ellipsis;
//  overflow: hidden;
//  -webkit-box-orient: vertical;
//  -webkit-line-clamp: 2;
//  word-break: break-all;
//}
.content-container-pc {
  height: 100%;
  .content-date-list {
    height: calc(100%);
    padding: 0 0.2rem;
    overflow-y: auto;
    .date-list-item {
      width: 100%;
      padding: 0.23rem 0;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      // border-bottom: 1px solid #eeeff2;
      cursor: pointer;
      &.active {
        .list-item-info {
          .item-info-title {
            min-height: 25px;
            color: #56B7F9;
          }
          .item-info-time {
            color: #56B7F9;
          }
        }
      }
      .list-item-img {
        margin-right: 0.12rem;
        display: flex;
      }
      .list-item-info {
        width: calc(100% - 1.4rem);
        margin-top: 0.04rem;
        .item-info-title {
          min-height: 25px;
          font-size: 0.21rem;
          font-weight: bold;
          color: #C7C7C7;
        }
        .item-info-time {
          margin-top: 0.09rem;
          font-size: 0.21rem;
          color: #747474;
          display: flex;
          justify-content: space-between;
          //align-items: center;
          .van-image {
            margin-right: 0.05rem;
            vertical-align: text-top;
          }
          .van-icon {
            margin-right: 0.05rem;
            font-size: 0.22rem;
            vertical-align: sub;
          }
        }
      }
    }
  }
}
.content-container {
  height: 100%;
  .content-date-list {
    height: calc(100%);
    padding: 0 0.2rem;
    overflow-y: auto;
    .date-list-item {
      width: 100%;
      padding: 0.23rem 0;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      border-bottom: 1px solid #eeeff2;
      cursor: pointer;
      &.active {
        .list-item-info {
          .item-info-title {
            min-height: 25px;
            color: #2284E5;
          }
          .item-info-time {
            color: #2284E5;
          }
        }
      }
      .list-item-img {
        margin-right: 0.12rem;
        display: flex;
      }
      .list-item-info {
        width: calc(100% - 1.4rem);
        margin-top: 0.04rem;
        .item-info-title {
          min-height: 25px;
          font-size: 0.22rem;
          font-weight: bold;
          color: #333333;
        }
        .item-info-time {
          margin-top: 0.09rem;
          font-size: 0.19rem;
          color: #9b9b9b;
          display: flex;
          justify-content: space-between;
          .van-image {
            margin-right: 0.05rem;
            vertical-align: text-top;
          }
          .van-icon {
            margin-right: 0.05rem;
            font-size: 0.22rem;
            vertical-align: sub;
          }
        }
      }
    }
  }
}
</style>
